@import '../../sass/components/input';
@import '../../sass/components/form-field';

som-input {
  /* Firefox puts a red shadow on required inputs. We remove it here. */
  input:required {
    box-shadow: none;
  }
}
